import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Search, ArrowLeft, Sparkles } from 'lucide-react';

export default function NotFound() {
  return (
    <main
      id="main-content"
      className="linkit-owned-page min-h-screen flex flex-col items-center justify-center px-6 py-16 text-center"
      style={{ background: 'linear-gradient(145deg, #0f172a 0%, #1e1b4b 40%, #0f172a 100%)' }}
    >
      <div className="relative mb-8">
        <div className="w-20 h-20 rounded-3xl bg-gradient-to-br from-pink-500 via-rose-500 to-orange-400 flex items-center justify-center text-white text-3xl font-black shadow-2xl shadow-pink-500/30">
          4
        </div>
        <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-amber-400 flex items-center justify-center text-slate-950 text-xs font-black animate-bounce shadow-lg">
          !
        </div>
      </div>

      <p className="text-xs font-black tracking-[0.2em] uppercase text-pink-400 mb-4">
        Page not found
      </p>

      <h1 className="text-4xl sm:text-5xl md:text-6xl font-black text-white tracking-tight leading-[0.95] max-w-lg">
        This page doesn't exist
      </h1>

      <p className="mt-6 text-base sm:text-lg font-semibold text-slate-400 max-w-md leading-relaxed">
        The link you followed may be broken, or the page may have been removed. Let's get you back on track.
      </p>

      <nav className="mt-10 flex flex-wrap gap-3 justify-center" aria-label="Recovery navigation">
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-2xl bg-white text-slate-950 text-sm font-bold shadow-xl shadow-white/10 hover:shadow-white/20 hover:scale-[1.03] transition-all duration-300"
        >
          <Home size={16} />
          Go Home
        </Link>
        <Link
          to="/discover"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-2xl bg-white/10 text-white text-sm font-bold border border-white/10 hover:bg-white/15 hover:scale-[1.03] transition-all duration-300 backdrop-blur-sm"
        >
          <Search size={16} />
          Discover Creators
        </Link>
        <button
          onClick={() => window.history.back()}
          className="inline-flex items-center gap-2 px-6 py-3 rounded-2xl bg-white/5 text-slate-300 text-sm font-bold border border-white/5 hover:bg-white/10 hover:scale-[1.03] transition-all duration-300"
        >
          <ArrowLeft size={16} />
          Go Back
        </button>
      </nav>

      <div className="mt-16 flex items-center gap-2 text-slate-600 text-xs font-semibold">
        <Sparkles size={12} />
        <span>Powered by Linkit</span>
      </div>
    </main>
  );
}
